(function () {
    'use strict';

    angular.module('swif.ui')
    .directive('swifIenomore', swifIenomore);

    /**
     * @ngdoc directive
     * @name swif.ui:swifIenomore
     * @module swif.ui
     * @restrict E
     * @description display message to ie users
     */
    function swifIenomore() {
        return {
            restrict: 'E',
            scope: {},
            templateUrl: 'partials/ui/ienomore.html'
        };
    }

})();
